export default __webpack_public_path__ + "static/media/01.5f3d09b2.jpg";